<template>
  <div class="default-job-list">
    <div class="single-info" v-for="(com, index) in data" :key="index">
      <p class="com-info">
        <span class="com-name"></span>
        <span class="com-name-text">
        {{ com.i18n_name }}
        </span>
      </p>
      <ul class="common-wrapper">
        <li class="job-coloum-info-container" v-for="(job, jobIndex) in com.job_data" :key="jobIndex">
          <div class="job-info" @click="jobApply(job)">
            <div class="job-title" :class="showReferral(job) && 'has-referral-title'">
              <span v-if="job.hot" class="hot_job_icon"></span>
              <a class="job-name ellipsis">{{ job.title }}</a>
            </div>
            <div v-if="showReferral(job)" class="job-referral-icon">
              <i class="iconfont iconhongbao1"></i>
            </div>
            <div class="job-company-container">
              <div class="job-company">
                {{ job.city_name || job.cities.join(' ')}}
              </div>
              <span class="create-time">{{ job.updated_time }}</span>
            </div>
            <div class="detail-info">
              <span v-if="showSalary" class="salary">{{ job.salary }}</span>
              <span class="work-time">
                {{ workTime(job) }}
              </span>
              <span class="role-type">{{ job.role_type }}</span>
              <span class="distance">
                {{ job.distance && job.distance | formatDistance }}{{job.distance && 'km'}}
              </span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  props: {
    data: {
      type: Array,
      required: true
    },
    company: {
      type: Object,
      required: true
    },
    showSalary: {
      type: Boolean,
      required: true
    },
    has_referral_word_customized: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  methods: {
    ...mapActions('referral', ['getJobReferralUrl']),
    async jobApply (job) {
      const listReferralId = this.$route.query.lReferId
      const jobId = job.pk
      let url = ''
      if (listReferralId) {
        url = await this.getJobReferralUrl({ listReferralId, jobId })
      }
      if (!url) {
        const id = job.short_unique_id
        url = `/job-description/${id}/?company_id=${this.company.id}`
      }
      this.$router.push({ path: url, query: this.$route.query })
    },
    showReferral (job) {
      return job.referral_settings && job.referral_settings.to_show_referral && job.job_visibility !== 'I'
    },
    workTime (job) {
      if (this.company.root_company.id !== 4335) {
        if (job.job_visibility === 'I') {
          return this.$t('companyJobList.internalJob')
        } else if (job.job_visibility === 'E') {
          return this.$t('companyJobList.externalJob')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.default-job-list {
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  .job-coloum-info-container {
    position: relative;

    .job-info {
      .job-title {
        line-height: initial;
      }

      .job-referral-icon {
        width: 20px;
        height: 25px;
        text-align: center;
        overflow: hidden;
        color: var(--custom-color, #fd8232);
        position: absolute;
        top: 12px;
        right: -3px;

        i {
          font-size: 32px;
          position: absolute;
          top: 1px;
          left: -6px;
        }
      }
    }
  }
}
</style>
